<script lang="ts">
  import {
    userInfoStore,
    currentUserStore,
    initAuthProcess,
  } from "../app/store/store-user";
  import {
    handleAuthRedirectAfterLogin,
    storeAuthRedirectSession,
  } from "../app/api";

  storeAuthRedirectSession();
  let isLoggedIn = false;

  $: userInfo = $userInfoStore;
  $: currentUser = $currentUserStore;
  $: isLoggedIn = currentUser?.emailVerified && !!userInfo?.plan;
  $: if (isLoggedIn) {
    handleAuthRedirectAfterLogin(userInfo);
  }
</script>

{#if $initAuthProcess}
  <slot />
{/if}
